"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = exports.useTranslate = void 0;
const utils_language_1 = require("@unboared/utils.language");
const i18n_js_1 = __importDefault(require("i18n-js"));
exports.i18n = i18n_js_1.default;
i18n_js_1.default.fallbacks = true;
/**
 * Translates text.
 *
 * @param key The i18n key.
 */
function translate(key, options) {
    return key ? i18n_js_1.default.t(key, options) : null;
}
const useTranslate = () => {
    const language = (0, utils_language_1.useLanguage)(state => state.language);
    return { translate };
};
exports.useTranslate = useTranslate;
//# sourceMappingURL=i18n.js.map